// ./src/ActionSheet/ReactionMenu.tsx
//
// "Add a reaction": the emoji palette behind a button — a dropdown on a desktop, a bottom sheet of big emoji on a phone
// (ResponsiveMenu). It was copied four times (crew comments, crew messages, the public guest book, guest messages).

import React from 'react';
import { ActionIcon, Group } from '@mantine/core';

import { ResponsiveMenu, ResponsiveMenuProps } from './ResponsiveMenu';

/** The reactions offered everywhere. ⚠ Mirrors the API's allow-list (`ALLOWED_REACTIONS`, eventsmagic-api src/boundary/comment.ts) — the server refuses any other. */
export const REACTION_PALETTE = ['👍', '👎', '❤️', '🎉', '😂', '😍', '🤔', '😮', '😢', '😡', '🔥', '👏', '🙏', '🥳', '💯', '😅'];

export interface ReactionMenuProps {
  /** The button that opens the palette. */
  target: ResponsiveMenuProps['target'];
  /** Picked: the palette closes after one. */
  onPick: (emoji: string) => void;
  /** Which reactions are already this person's (drawn highlighted). */
  isMine?: (emoji: string) => boolean;
  /** The phone sheet's title (default "Add a reaction"). */
  title?: React.ReactNode;
  position?: ResponsiveMenuProps['position'];
}

export const ReactionMenu: React.FC<ReactionMenuProps> = ({ target, onPick, isMine, title = 'Add a reaction', position = 'bottom-start' }) => (
  <ResponsiveMenu target={target} title={title} position={position} width={280}>
    {(close) => (
      // Spaced and wrapping in the desktop dropdown too (the sheet wraps its content; the dropdown draws it bare).
      <Group gap={4} p={4} wrap="wrap">
        {REACTION_PALETTE.map((emoji) => (
        <ActionIcon
          key={emoji}
          variant={isMine?.(emoji) ? 'light' : 'subtle'}
          color={isMine?.(emoji) ? 'blue' : 'gray'}
          size="xl"
          radius="md"
          aria-label={`React ${emoji}`}
          aria-pressed={!!isMine?.(emoji)}
          onClick={() => {
            close();
            onPick(emoji);
          }}
        >
          <span style={{ fontSize: 22, lineHeight: 1 }}>{emoji}</span>
        </ActionIcon>
        ))}
      </Group>
    )}
  </ResponsiveMenu>
);
